export const DISPOSITION_COLORS = {
  Interested: "bg-success",
  Contacted: "bg-warning",
  "Proposal Sent": "bg-info",
  Converted: "bg-success",
  "Not Interested": "bg-danger",
  "Denied by Us": "bg-danger",
  "Wrong No": "bg-secondary",
  "Did Not Pick Up": "bg-dark",
  "Escalated to Admin": "bg-purple",
  Others: "bg-light",
};